import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "margin-h3" }
const _hoisted_2 = {
  key: 0,
  class: "row gap-30"
}
const _hoisted_3 = { class: "toggle-switch-row" }
const _hoisted_4 = { class: "toggle-switch-row" }
const _hoisted_5 = { class: "toggle-switch-row" }
const _hoisted_6 = { class: "toggle-switch-row" }

import {
    AppointmentReminderPreferenceResponse,
    FindAppointmentReminderPreferencesRequest,
    ReminderPreferenceApi,
    UpdateAppointmentReminderPreferencesRequest,
} from "@/apiGenerate/medserver";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { ApiError } from "@/models/share.model";
import { useAppUserStore } from "@/stores/appUser";
import { toastError } from "@/utils/toast-utils";
import { ToggleSwitch, useToast } from "primevue";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'esNotificationSettings',
  setup(__props) {

const { t } = useI18n();
const toast = useToast();
const appUserStore = useAppUserStore();

const appointmentReminderPreferenceApi = new ReminderPreferenceApi(medServerApiConfig,);

const appointmentReminderPreferences = ref<AppointmentReminderPreferenceResponse | undefined>(undefined);
const isPending = ref<boolean>(false);

const instituteId = computed((): string | undefined => {
    if (
        !appUserStore.currentHealthGroupMembership ||
        !appUserStore.currentHealthGroupMembership.instituteWithRole ||
        !appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId
    ) {
        return undefined;
    }

    return appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId;
});

const findAppointmentReminderPreferences = async (instituteId: string) => {
    const findAppointmentReminderPreferencesRequest: FindAppointmentReminderPreferencesRequest = {
        instituteId: instituteId
    };

    isPending.value = true;

    appointmentReminderPreferenceApi.findAppointmentReminderPreferences(findAppointmentReminderPreferencesRequest)
        .then((newAppointmentReminderPreferences: AppointmentReminderPreferenceResponse) => {
            appointmentReminderPreferences.value = newAppointmentReminderPreferences;
        })
        .catch((error: ApiError) => {
            toastError(toast, {
                summary: t("common.toast.error"),
                detail: error.status ? t(`error.${error.status}`) : t("error.DEFAULT"),
            });
        })
        .finally(() => {
            isPending.value = false;
        });
};

const updateAppointmentReminderPreferences = (
    instituteId: string,
    updateAppointmentReminderPreferencesRequest: UpdateAppointmentReminderPreferencesRequest,
) => {
    isPending.value = true;

    appointmentReminderPreferenceApi.updateAppointmentReminderPreferences(updateAppointmentReminderPreferencesRequest)
        .then(async () => {
            const findAppointmentReminderPreferencesRequest: FindAppointmentReminderPreferencesRequest = {
                instituteId: instituteId,
            };

            await appointmentReminderPreferenceApi.findAppointmentReminderPreferences(findAppointmentReminderPreferencesRequest)
                .then((newAppointmentReminderPreferences: AppointmentReminderPreferenceResponse) => {
                    appointmentReminderPreferences.value = newAppointmentReminderPreferences;
                })
                .catch((error: ApiError) => {
                    toastError(toast, {
                        summary: t("common.toast.error"),
                        detail: error.status ? t(`error.${error.status}`): t("error.DEFAULT"),
                    });
                });
        })
        .catch((error: ApiError) => {
            toastError(toast, {
                summary: t("common.toast.error"),
                detail: error.status ? t(`error.${error.status}`) : t("error.DEFAULT"),
            });
        })
        .finally(() => {
            isPending.value = false;
        });
};

onMounted(async () => {
    if (instituteId.value) {
        await findAppointmentReminderPreferences(instituteId.value);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("settings.notification.reminderTitle")), 1),
    (appointmentReminderPreferences.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_unref(t)(`settings.notification.isTodayReminderEnabled`)) + " ", 1),
            _createVNode(_unref(ToggleSwitch), {
              disabled: isPending.value,
              "model-value": appointmentReminderPreferences.value.isTodayReminderEnabled,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (
                    updateAppointmentReminderPreferences(instituteId.value, {
                        reminderPreferenceId: appointmentReminderPreferences.value.uuid,
                        appointmentReminderPreferenceRequest: {
                            ...appointmentReminderPreferences.value,
                            isTodayReminderEnabled: !appointmentReminderPreferences.value.isTodayReminderEnabled,
                        },
                    })
                ))
            }, null, 8, ["disabled", "model-value"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_unref(t)(`settings.notification.isOneDayBeforeReminderEnabled`)) + " ", 1),
            _createVNode(_unref(ToggleSwitch), {
              disabled: isPending.value,
              "model-value": appointmentReminderPreferences.value.isOneDayBeforeReminderEnabled,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
                    updateAppointmentReminderPreferences(instituteId.value, {
                        reminderPreferenceId: appointmentReminderPreferences.value.uuid,
                        appointmentReminderPreferenceRequest: {
                            ...appointmentReminderPreferences.value,
                            isOneDayBeforeReminderEnabled: !appointmentReminderPreferences.value.isOneDayBeforeReminderEnabled,
                        },
                    })
                ))
            }, null, 8, ["disabled", "model-value"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_unref(t)(`settings.notification.isThreeDaysBeforeReminderEnabled`)) + " ", 1),
            _createVNode(_unref(ToggleSwitch), {
              disabled: isPending.value,
              "model-value": appointmentReminderPreferences.value.isThreeDaysBeforeReminderEnabled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (
                    updateAppointmentReminderPreferences(instituteId.value, {
                        reminderPreferenceId: appointmentReminderPreferences.value.uuid,
                        appointmentReminderPreferenceRequest: {
                            ...appointmentReminderPreferences.value,
                            isThreeDaysBeforeReminderEnabled: !appointmentReminderPreferences.value.isThreeDaysBeforeReminderEnabled,
                        },
                    })
                ))
            }, null, 8, ["disabled", "model-value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_unref(t)(`settings.notification.isOneWeekReminderEnabled`)) + " ", 1),
            _createVNode(_unref(ToggleSwitch), {
              disabled: isPending.value,
              "model-value": appointmentReminderPreferences.value.isOneWeekReminderEnabled,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (
                    updateAppointmentReminderPreferences(instituteId.value, {
                        reminderPreferenceId: appointmentReminderPreferences.value.uuid,
                        appointmentReminderPreferenceRequest: {
                            ...appointmentReminderPreferences.value,
                            isOneWeekReminderEnabled: !appointmentReminderPreferences.value.isOneWeekReminderEnabled,
                        },
                    })
                    ))
            }, null, 8, ["disabled", "model-value"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})